// @flow
import { connect } from 'react-redux';
import { getDualColors } from '../../schedule-type';
import { getScheduleType } from '~/core/state/ui/schedule/selectors';
import SVGDefinitions from './component';

const mapStateToProps = (state, { componentId }) => {
    const scheduleType = getScheduleType(state, { componentId });
    const dualColors = getDualColors({ type: scheduleType });

    return {
        ...dualColors
    };
};

// $FlowFixMe
export default connect(mapStateToProps)(SVGDefinitions);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/svg-container/definitions/index.js